import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Modal = ({ open, closeModal, content, closable, quitModal, type, fullHeight }) => {
  const closeImageModal = event => {
    closeModal();
  };

  return (
    open && (
      <Root
        hasImage={type === 'image' ? 1 : 0}
        onClick={type === 'image' && closeImageModal}
        image={type === 'image'}
        fullHeight={fullHeight ? 1 : 0}
      >
        <div className="modalBackground">
          {closable && <Close onClick={quitModal}>X</Close>}
          <div className="modalContent">
            {content}
            {closeModal && type !== 'image' && type !== 'SUCCESS' && (
              <div className="buttonWrapper">
                <Button type="button" onClick={closeModal}>
                  Megértettem
                </Button>
              </div>
            )}
          </div>
        </div>
      </Root>
    )
  );
};

export default Modal;

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  closable: PropTypes.bool,
  quitModal: PropTypes.func.isRequired,
  type: PropTypes.string,
  content: PropTypes.node,
  fullHeight: PropTypes.bool
};

Modal.defaultProps = {
  closable: true,
  type: 'default',
  content: '',
  fullHeight: false
};

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);

  & .modalBackground {
    position: fixed;
    background-color: white;
    box-shadow: -1px 13px 36px 9px rgba(0, 0, 0, 0.51);
    width: ${props => (props.hasImage ? 'auto' : '90%')};
    max-width: 800px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    height: ${props => (props.fullHeight ? '' : '500px')};

    & .modalContent {
      width: ${props => (props.image ? 'auto' : '100%')};
      max-height: 100%;
      /* max-height: 100vh; */
      padding: ${props => (props.image || props.fullHeight ? '0' : '0 3em')};
      overflow-y: ${props => (props.hasImage ? 'hidden' : 'auto')};

      & img {
        max-width: 100%;
        max-height: 500px;
        object-fit: contain;
      }

      & h3 {
        text-align: center;
      }

      @media (max-width: 800px) {
        font-size: 0.75em;
        padding: 0 1em;
        max-height: 500px;
      }

      & .buttonWrapper {
        width: 100%;
        text-align: right;
        margin-bottom: 1em;
      }
    }
  }
`;

const Button = styled.button`
  background-color: #e80000;
  border: none;
  color: white;
  height: 40px;
  border-radius: 60px;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 1em;
  font-family: 'Cousine', Cousine-Family;
  width: 200px;

  &:hover {
    background-color: #df0101;
  }

  &:focus {
    outline: none;
  }
`;

const Close = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background-color: #e80000;
  color: white;
  font-size: 22px;
  font-weight: 700;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  top: -18px;
  right: -18px;
  cursor: pointer;
`;
